firebird.factory('themedFeaturesService', [
    '$rootScope',
    '$window',
    'storageService',
    'logService',
    'localizationService',
    'config',
    function ($rootScope, $window, storageService, logService, localizationService, config) {
        var themedFeaturesAvailable = false,
            themedFeaturesEnabled = !!storageService.get('themedFeaturesEnabled');

        // Easily change between themes with currentTheme value and start/end date in config.themedFeaturesEndDate
        // Current Themes List: halloween, winter, spring
        var currentTheme = 'winter';

        var themes = {
            halloween: {
                vbg: {
                    'themed-bg1': {
                        url: '/img/redesign/virtualBackgrounds/halloween/bg1.jpg',
                        label: 'Halloween BG 1'
                    },
                    'themed-bg2': {
                        url: '/img/redesign/virtualBackgrounds/halloween/bg2.jpg',
                        label: 'Halloween BG 2'
                    },
                    'themed-bg3': {
                        url: '/img/redesign/virtualBackgrounds/halloween/bg3.jpg',
                        label: 'Halloween BG 3'
                    },
                    'themed-bg4': {
                        url: '/img/redesign/virtualBackgrounds/halloween/bg4.jpg',
                        label: 'Halloween BG 4'
                    }
                },
                reactions: [
                    {
                        name: 'ghost',
                        url: '/img/redesign/icons/themed-reactions/ghost.svg'
                    },
                    {
                        name: 'pumpkin',
                        url: '/img/redesign/icons/themed-reactions/pumpkin.svg'
                    },
                    {
                        name: 'spider',
                        url: '/img/redesign/icons/themed-reactions/spider.svg'
                    },
                    {
                        name: 'goblin',
                        url: '/img/redesign/icons/themed-reactions/goblin.svg'
                    },
                    {
                        name: 'devil',
                        url: '/img/redesign/icons/themed-reactions/devil.svg'
                    },
                    {
                        name: 'candy',
                        url: '/img/redesign/icons/themed-reactions/candy.svg'
                    },
                    {
                        name: 'reaper',
                        url: '/img/redesign/icons/themed-reactions/reaper.svg'
                    },
                    {
                        name: 'cauldron',
                        url: '/img/redesign/icons/themed-reactions/cauldron.svg'
                    }
                ],
                icons: {
                    enabled: '/img/redesign/icons/themed-icons/pumpkin-color.png',
                    disabled: '/img/redesign/icons/themed-icons/pumpkin-white.png'
                }
            },
            winter: {
                vbg: {
                    'themed-bg1': {
                        url: '/img/redesign/virtualBackgrounds/winter/bg1.jpg',
                        label: 'Winter BG 1'
                    },
                    'themed-bg2': {
                        url: '/img/redesign/virtualBackgrounds/winter/bg2.jpg',
                        label: 'Winter BG 2'
                    },
                    'themed-bg3': {
                        url: '/img/redesign/virtualBackgrounds/winter/bg3.jpg',
                        label: 'Winter BG 3'
                    },
                    'themed-bg4': {
                        url: '/img/redesign/virtualBackgrounds/winter/bg4.jpg',
                        label: 'Winter BG 4'
                    }
                },
                reactions: [
                    {
                        name: 'present',
                        url: '/img/redesign/icons/themed-reactions/present.png'
                    },
                    {
                        name: 'star',
                        url: '/img/redesign/icons/themed-reactions/star.png'
                    },
                    {
                        name: 'snowflake',
                        url: '/img/redesign/icons/themed-reactions/snowflake.png'
                    },
                    {
                        name: 'sparkler',
                        url: '/img/redesign/icons/themed-reactions/sparkler.png'
                    },
                    {
                        name: 'snowman',
                        url: '/img/redesign/icons/themed-reactions/snowman.png'
                    },
                    {
                        name: 'popper',
                        url: '/img/redesign/icons/themed-reactions/popper.png'
                    },
                    {
                        name: 'santa',
                        url: '/img/redesign/icons/themed-reactions/santa.png'
                    },
                    {
                        name: 'wind',
                        url: '/img/redesign/icons/themed-reactions/wind.png'
                    }
                ],
                icons: {
                    enabled: '/img/redesign/icons/themed-icons/snowflake-on.svg',
                    disabled: '/img/redesign/icons/themed-icons/snowflake-off.svg'
                }
            },
            spring: {
                vbg: {
                    'themed-bg1': {
                        url: '/img/redesign/virtualBackgrounds/spring/bg1.jpg',
                        label: 'Spring BG 1'
                    },
                    'themed-bg2': {
                        url: '/img/redesign/virtualBackgrounds/spring/bg2.jpg',
                        label: 'Spring BG 2'
                    },
                    'themed-bg3': {
                        url: '/img/redesign/virtualBackgrounds/spring/bg3.jpg',
                        label: 'Spring BG 3'
                    },
                    'themed-bg4': {
                        url: '/img/redesign/virtualBackgrounds/spring/bg4.jpg',
                        label: 'Spring BG 4'
                    }
                },
                reactions: [
                    {
                        name: 'chick',
                        url: '/img/redesign/icons/themed-reactions/chick.png'
                    },
                    {
                        name: 'tulip',
                        url: '/img/redesign/icons/themed-reactions/tulip.png'
                    },
                    {
                        name: 'beehive',
                        url: '/img/redesign/icons/themed-reactions/beehive.png'
                    },
                    {
                        name: 'lemonade',
                        url: '/img/redesign/icons/themed-reactions/lemonade.png'
                    },
                    {
                        name: 'rabbit',
                        url: '/img/redesign/icons/themed-reactions/rabbit.png'
                    },
                    {
                        name: 'easter-eggs',
                        url: '/img/redesign/icons/themed-reactions/easter-eggs.png'
                    },
                    {
                        name: 'snail',
                        url: '/img/redesign/icons/themed-reactions/snail.png'
                    },
                    {
                        name: 'rainbow',
                        url: '/img/redesign/icons/themed-reactions/rainbow.png'
                    }
                ],
                icons: {
                    enabled: '/img/redesign/icons/themed-icons/tulip-on.svg',
                    disabled: '/img/redesign/icons/themed-icons/tulip-off.svg'
                }
            }
        };

        var service = {
            setThemedFeaturesAvailable: setThemedFeaturesAvailable,
            getThemedFeaturesAvailable: getThemedFeaturesAvailable,
            setThemedFeaturesEnabled: setThemedFeaturesEnabled,
            getThemedFeaturesEnabled: getThemedFeaturesEnabled,
            getThemedVBGs: getThemedVBGs,
            getThemedReactions: getThemedReactions,
            getThemeTooltips: getThemeTooltips,
            isBetweenThemeStartAndEndDate: isBetweenThemeStartAndEndDate,
            getThemeIcons: getThemeIcons,
            getThemeType: getThemeType
        };

        $rootScope.$on('theme-state-changed', onThemeStateChanged);

        return service;

        ////////////////////////

        function setThemedFeaturesAvailable(newFlag) {
            themedFeaturesAvailable = newFlag;
        }

        function getThemedFeaturesAvailable() {
            return themedFeaturesAvailable;
        }

        function setThemedFeaturesEnabled(newFlag) {
            themedFeaturesEnabled = newFlag;

            storageService.set('themedFeaturesEnabled', newFlag);

            $rootScope.$broadcast('themed-features-toggled', { enabled: newFlag });
        }

        function getThemedFeaturesEnabled() {
            return themedFeaturesAvailable && themedFeaturesEnabled;
        }

        function getThemedVBGs() {
            return themes[currentTheme].vbg;
        }

        function getThemedReactions() {
            return themes[currentTheme].reactions;
        }

        function getThemeIcons() {
            return themes[currentTheme].icons;
        }

        function getThemeTooltips() {
            var tooltips = {
                enable: localizationService.translate('HEADER.TOOLTIP.ENABLE_WINTER_THEME'),
                disable: localizationService.translate('HEADER.TOOLTIP.DISABLE_WINTER_THEME')
            };
            return tooltips;
        }

        function isBetweenThemeStartAndEndDate() {
            return (
                $window.moment().isSameOrAfter(config.themedFeaturesStartDate) &&
                $window.moment().isBefore(config.themedFeaturesEndDate)
            );
        }

        function onThemeStateChanged(e, enabled) {
            if (service.isBetweenThemeStartAndEndDate()) {
                service.setThemedFeaturesAvailable(enabled);
                $rootScope.$broadcast('themed-features-toggled', { enabled: enabled });
            }
        }

        function getThemeType() {
            return currentTheme;
        }
    }
]);
